const CommunityEditButtonBox = ({ title = "편집", onClick }) => {
    return (
        <button type="button" className="btn negative" onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export default CommunityEditButtonBox;